var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3059 7C14.3059 10.875 11.1497 14 7.30591 14C5.11841 14 3.11841 13.0312 1.77466 11.3125C1.58716 11.0938 1.64966 10.7812 1.86841 10.625C2.08716 10.4375 2.39966 10.5 2.55591 10.7188C3.71216 12.1875 5.43091 13 7.30591 13C10.5872 13 13.3059 10.3125 13.3059 7C13.3059 3.71875 10.5872 1 7.30591 1C5.14966 1 3.18091 2.15625 2.11841 4H4.80591C5.05591 4 5.30591 4.25 5.30591 4.5C5.30591 4.78125 5.05591 5 4.80591 5H0.805908C0.524658 5 0.305908 4.78125 0.305908 4.5V0.5C0.305908 0.25 0.524658 0 0.805908 0C1.05591 0 1.30591 0.25 1.30591 0.5V3.4375C2.55591 1.3125 4.80591 0.03125 7.30591 0.03125C11.1497 0.03125 14.3059 3.15625 14.3059 7Z",
    fill: "#646464"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/restore.dab45398.svg";
export { ForwardRef as ReactComponent };